import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import Cookies from "js-cookie";
import { Star } from "lucide-react";
import { useState, useEffect } from "react";
import { useParams } from "react-router";

import { useAlert } from "../../constants/AlertProvider";

export default function Skills() {
  const { candidateId: routeCandidateId } = useParams();
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    phone_number: "",
    address: "",
  });
  const [applicationId, setApplicationId] = useState(null);
  const [skills, setSkills] = useState([]);
  const [isRecruiterView, setIsRecruiterView] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const showAlert = useAlert();

  useEffect(() => {
    const fetchSkills = async () => {
      try {
        setIsLoading(true);
        const loggedInUserId = Cookies.get("id");
        const targetUserId = routeCandidateId || loggedInUserId;

        if (!targetUserId) {
          throw new Error("Target User ID is missing");
        }

        if (routeCandidateId) {
          setIsRecruiterView(true);
        }

        let userRes;
        if (isRecruiterView) {
          userRes = await axios.get(`/api/candidate-profile/${targetUserId}/`, {
            withCredentials: true,
          });
        } else {
          userRes = await axios.get(`/api/users/${targetUserId}/`, {
            withCredentials: true,
          });
        }
        const userProfileData = userRes.data;
        setUserData(userProfileData);

        if (
          userProfileData.applicationids &&
          userProfileData.applicationids.length > 0
        ) {
          const appId = userRes.data.applicationids[0].id;
          setApplicationId(appId);

          const skiResponse = await axios.get(
            `/api/skill/?application_id=${appId}`,
            {
              headers: { "X-CSRFToken": Cookies.get("csrftoken") },
              withCredentials: true,
            },
          );

          if (skiResponse.data && Array.isArray(skiResponse.data.results)) {
            setSkills(skiResponse.data.results);
          } else {
            throw new Error("Invalid API response format");
          }
        } else {
          setSkills([]);
        }
      } catch (error) {
        showAlert("Failed to fetch education.", "error");
        console.error("Error fetching skills:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSkills();
  }, [showAlert, routeCandidateId, isRecruiterView]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-8">
        <CircularProgress color="primary" size={30} />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {skills.length === 0 ? (
        <div className="text-center py-12 rounded-lg">
          <Star className="mx-auto h-12 w-12 text-gray-400 dark:text-gray-500" />
          <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-gray-100">
            No Skills Added
          </h3>
          {!isRecruiterView && (
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              Your skills will be displayed here. You can add it by editing your
              profile.
            </p>
          )}
        </div>
      ) : (
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
              Skills ({skills.length})
            </h2>
          </div>

          <div className="flex flex-wrap gap-3">
            {skills.map((skill) => (
              <div
                key={skill.id}
                className="bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-300 text-sm font-medium capitalize px-4 py-2 rounded-full transition-colors hover:bg-blue-200 dark:hover:bg-blue-900/60"
              >
                {skill.name}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
